import { Button } from "@mui/material";

import AlertConfirm from "commons/ui/alert/AlertConfirm";
import DataTable from "commons/ui/datatable/DataTable";
import { GridColumn, GridItem, GridRow } from "commons/ui/Grid";
import Paper from "commons/ui/Paper";

import CollectionTableFilters from "components/subComponents/CollectionTableFilters";

import useCollectionList from "hooks/list/useCollectionList";

function ElencoCollezioni() {
    const collectionListHook = useCollectionList();

    const { navigateToNewCollection, alertConfirmHook, dataTableHook } = collectionListHook;

    return (
        <GridColumn>
            <AlertConfirm alertConfirmHook={alertConfirmHook} />

            <GridItem>
                <Paper className={"table-with-filters"}>
                    <CollectionTableFilters collectionListHook={collectionListHook} />

                    <DataTable dataTableHook={dataTableHook} />
                </Paper>
            </GridItem>

            <GridRow justifyContent={"right"}>
                <GridItem className={"button-under-paper"}>
                    <Button variant={"contained"} onClick={navigateToNewCollection}>
                        Nuova Collection
                    </Button>
                </GridItem>
            </GridRow>
        </GridColumn>
    );
}

export default ElencoCollezioni;
